@use 'sass:map';
@use 'common/assets/scss/global' as *;
@import '@fortawesome/fontawesome-svg-core/styles.css';

@keyframes shimmer {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}

.service-info {
  > .header {
    display: flex;
    flex-direction: column;
    gap: 16px;

    > .heading {
      display: flex;
      gap: 8px;
      align-items: center;

      > .icon {
        flex: 0 0 auto;
        height: 70px;
        width: 70px;
        color: HEXToRGBA($black, 0.3);

        &.skeleton {
          border-radius: 4px;
          background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite linear;
        }

        > image {
          width: 100%;
          height: 100%;
        }
      }

      > .heading {
        &-text {
          > h1 {
            margin: 0;

            &.skeleton {
              width: 180px;
              height: 1em;
              border-radius: 50px;
              background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite linear;
            }
          }

          > .origin {
            display: block;
            font-style: italic;
            font-size: var(--#{$prefix}font-size-sm);
            line-height: 150%;
          }

          > .tag-category {
            margin-top: 9px;

            &.skeleton {
              width: 150px;
              height: 33px;
              border-radius: 50px;
              background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite linear;
            }
          }
        }
      }
    }

    > a,
    > button {
      width: 100%;
    }
  }

  > .content {
    display: flex;
    flex-direction: column;
    gap: 24px 58px;
    padding: 24px 0;

    > .error {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      flex-grow: 1;

      > svg {
        font-size: 38px;
        margin-bottom: 14px;
        opacity: 0.1;
      }

      > p {
        white-space-collapse: preserve-breaks;
      }
    }

    > section {
      &.first-step {
        > .video {
          display: flex;
          align-items: center;
          border-radius: 4px;
          overflow: hidden;

          > * {
            aspect-ratio: 16/9;
            width: 100%;
            height: auto;

            &.skeleton {
              background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite linear;
            }
          }
        }
      }

      &.description {
        > div {
          line-height: 150%;

          a {
            @include text-link;
          }

          h1,
          h2,
          h3,
          p,
          blockquote,
          .media,
          ul,
          ol {
            &:not(:last-child) {
              margin-bottom: 1em;
            }
          }

          h1,
          h2,
          h3 {
            &:not(:first-child) {
              margin-top: 1em;
            }
          }

          ul,
          ol {
            margin-left: 2em;

            > li:not(:last-child) {
              margin-bottom: 0.5em;
            }
          }

          img {
            max-width: 100%;
          }

          figure.media iframe {
            max-width: 100%;
          }

          &.skeleton {
            > * {
              width: 100%;
              height: 1em;
              border-radius: 50px;
              background: linear-gradient(90deg, #e9e9e9 30%, #f6f6f6 50%, #e9e9e9 70%);
              background-size: 200% 100%;
              animation: shimmer 1.5s infinite linear;

              &:last-child {
                width: 50%;
              }
            }
          }
        }
      }

      &.ressources {
        > ul {
          @include unstyled-list;

          > li > a {
            @include list-link;
            color: var(--#{$prefix}system-blue);
            line-height: 250%;
          }
        }

        > a,
        > button {
          margin-top: 16px;
          font-size: unset;
        }
      }
    }
  }

  > footer {
    display: flex;
    flex-direction: column;
    gap: 16px;

    > a,
    > button {
      width: 100%;

      &.launch > svg {
        display: none;
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, sm)) {
    > .header {
      gap: 8px;

      > .heading > .icon {
        height: 100px;
        width: 100px;
      }
    }
  }

  @media (width >= map.get($grid-breakpoints, md)) {
    > .header {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding-right: 24px;

      > .heading {
        margin: 0;
      }

      > a,
      > button {
        width: unset;
      }
    }

    > .content {
      flex-direction: row;
      flex-wrap: wrap;
      padding: 24px;

      > section {
        &.description {
          flex: 1 0 100%;

          > h2 {
            @include sr-only;
          }
        }

        &.first-step,
        &.ressources {
          flex: 1 0 45%;
        }

        > ul > li > a {
          font-weight: bold;
        }
      }
    }

    > footer {
      flex-direction: row;
      justify-content: space-between;
      padding-top: 32px;

      > a,
      > button {
        width: unset;

        &.launch > svg {
          display: unset;
        }
      }
    }
  }
}
